export default __webpack_public_path__ + "static/media/edit.fd32f260.svg";